import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { environment } from "src/environments/environment";

import { RegistrationService } from 'src/app/services/registration.service';

@Injectable()
export class RegistrationResolver implements Resolve<any> {
  constructor(private registrationService: RegistrationService) {}

  public resolve(route: ActivatedRouteSnapshot) {
    const params = {
      clientKey: environment.apiClientKey,
      secretKey: environment.apiSecretKey
    };

    return this.registrationService
      .generateToken(params)
      .toPromise()
      .then((result: any) => {
        return result.token;
      })
      .catch(error => {});
  }
}
